import { useTranslation } from "../../../../language";

export default function ChangeSubText() {
  const { t } = useTranslation();
  return <span>{t("sub_change_subtext")}</span>;
}
